'use client';

import * as React from 'react';
import { AUTH_STATUS } from '../../constants';
type AuthStatus = (typeof AUTH_STATUS)[keyof typeof AUTH_STATUS];
type SetAuthStatusToAuthenticatedHandler = React.Dispatch<void>;
type SetAuthStatusToNotAuthenticatedHandler = React.Dispatch<void>;
interface AuthStateContextValue {
  authStatus: AuthStatus;
  setAuthStatusToAuthenticated: SetAuthStatusToAuthenticatedHandler;
  setAuthStatusToNotAuthenticated: SetAuthStatusToNotAuthenticatedHandler;
}
export const AuthStateContext = React.createContext<AuthStateContextValue>(undefined!);
interface AuthStateProviderProps extends React.PropsWithChildren {
  status: AuthStatus;
}

/**
 * @useClient
 */
export const AuthStateProvider = React.memo(function AuthStateProvider({
  status,
  children
}: AuthStateProviderProps) {
  const [authStatus, setAuthStatus] = React.useState(() => status);
  React.useEffect(() => {
    setAuthStatus(() => status);
  }, [status]);
  const providerValue = React.useMemo(() => {
    return {
      authStatus,
      setAuthStatusToAuthenticated: () => setAuthStatus(() => AUTH_STATUS.AUTHENTICATED),
      setAuthStatusToNotAuthenticated: () => setAuthStatus(() => AUTH_STATUS.NOT_AUTHENTICATED)
    };
  }, [authStatus]);
  return <AuthStateContext.Provider value={providerValue}>{children}</AuthStateContext.Provider>;
});